import { GATEWAY_URL, ACCESS_TOKEN } from '../constants';

const request = (options, token, tenant) => {
  const headers = new Headers({
    'Content-Type': 'application/json',
  })
  if (token) {
    headers.append("Authorization", `Bearer ${token}`)
  }
  if (tenant) {
    headers.append("tenant-id", tenant)
  }
  const defaults = { headers: headers, credentials: "include" };
  options = Object.assign({}, defaults, options);
  return new Promise((resolve, reject) => {
    fetch(options.url, options)
      .then(response => {
          resolve(response);
        }
      ).catch(e => {
      reject(e)
    });
  })
};

export function getCurrentUser() {
  if (!localStorage.getItem(ACCESS_TOKEN)) {
    return Promise.reject("No access token set.");
  }

  return request({
    url: GATEWAY_URL + "/api/account",
    method: 'GET'
  });
}

export function login(loginRequest) {
  return request({
    url: GATEWAY_URL + "/api/authenticate",
    method: 'POST',
    body: JSON.stringify(loginRequest)
  });
}

export function activate(key) {
  return request({
    url: GATEWAY_URL + "/api/activate?key="+key,
    method: 'get',
    // params: {
    //   key
    // }
  });
}

export function signup(signupRequest) {
  return request({
    url: GATEWAY_URL + "/api/register",
    method: 'POST',
    body: JSON.stringify(signupRequest)
  });
}


export function getFields(){
  return request({
    url: GATEWAY_URL + "/services/call/api/fields?page=0&size=1000",
    method: 'GET',
  })
}

export function getNations(){
  return request({
    url: GATEWAY_URL + "/services/call/api/nation?page=0&size=1000",
    method: 'GET'
  })
}

export function getProvinces(id){
  return request({
    url: GATEWAY_URL + `/services/call/api/province/nation/${id}?page=0&size=1000`,
    method: 'GET'
  })
}

export function forgotPassword(data) {
  return request({
    url: GATEWAY_URL + "/services/gateway/api/account/reset-password/init",
    method: 'POST',
    body: data
  });
}

export function resetPassword(data) {
  return request({
    url: GATEWAY_URL + "/services/gateway/api/account/reset-password/finish",
    method: 'POST',
    body: JSON.stringify(data)
  });
}

export function changePass(activeRequest) {
  return request({
    url: GATEWAY_URL + "/services/gateway/api/account/change-password",
    method: 'POST',
    body: JSON.stringify(activeRequest)
  });
}

export function getAllTenant(token) {
  return request({
    url: GATEWAY_URL + "/services/org/api/tenant/my-tenant-to-switch",
    method: 'GET',
    headers: token && {
      Authorization: `Bearer ${token}`,
      "Tenant-id": 0
    }
  });
}

export function getUser(token) {
  return request({
    url: GATEWAY_URL + "/services/gateway/api/account",
    method: 'GET',
    headers: token && {
      Authorization: `Bearer ${token}`,
      "Tenant-id": 0
    }
  });
}

export function finishChangeEmail(key) {
  return request({
    url: GATEWAY_URL + `/services/gateway/api/account/reset-email/finish?key=${key}`,
    method: 'POST'
  });
}
